// ------------------------ Image gallery
const galleryTriggers = document.querySelectorAll('button.open-image-gallery');
if(galleryTriggers.length > 0) {
    galleryTriggers.forEach((button) => {
        button.addEventListener('click', () => {
            document.documentElement.classList.add('object-gallery-active');
            // Set scroll top top inside overlay
            const galleryTop = document.querySelector('.gallery-overlay .top');
            if(galleryTop){
                galleryTop.scrollIntoView();
            }
        });
    });
}
const galleryClose = document.querySelectorAll('button.close-image-gallery');
if(galleryClose.length > 0) {
    galleryClose.forEach((button) => {
        button.addEventListener('click', () => {
            document.documentElement.classList.remove('object-gallery-active');
        });
    });
}
// Also detect esc click and close overlay from that
document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape') {
        document.documentElement.classList.remove('object-gallery-active');
    }
});
// Scroll down to contact form
const galleryContact = document.querySelectorAll('button.gallery-contact');
if(galleryContact.length > 0) {
    galleryContact.forEach((button) => {
        button.addEventListener('click', () => {
            const bottomTemplate = document.querySelector('.gallery-overlay .bottom-template');
            if(bottomTemplate){
                bottomTemplate.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}
// Bidding
jQuery('button.toggle-history').on('click', function() {
    jQuery('.bid-history-list').slideToggle(200);
    jQuery(this).toggleClass('open');
});
// Viewings
function dateInPast(firstDate, secondDate) {
    let firstUnix = Math.floor(firstDate.getTime() / 1000);
    let secondUnix = Math.floor(secondDate.getTime() / 1000);
    return firstUnix < secondUnix;
}
function lookForViewings(viewings) {
    const viewingWidgets = document.querySelectorAll('.vitec-viewings');
    if (viewingWidgets) {
        viewingWidgets.forEach((viewingWidget) => {
            let viewingString = '';
            let inList = viewingWidget.classList.contains('in-list');
            let viewings = JSON.parse(viewingWidget.dataset.viewings);
            viewings.forEach((viewing) => {
                let endTime = new Date(viewing.endTime);
                let now = new Date();
                if (dateInPast(endTime, now)) {
                    // Skip
                } else {
                    // Detect if a real time was set. When the client adds no time,
                    // the system stores 00:00, so we hide the hour/minute in that case.
                    let startDate = new Date(viewing.startTime);
                    let hasTime = startDate.getHours() !== 0 || startDate.getMinutes() !== 0;

                    // Format date string
                    const options = {
                        month: 'long',
                        day: 'numeric',
                    };

                    if (hasTime) {
                        options.hour = 'numeric';
                        options.minute = 'numeric';
                    }

                    viewingString = startDate.toLocaleDateString('sv-SE', options);
                    viewingString = viewingString.replace('kl. ', '');

                    // Remove hour in list (only when a time is present)
                    if (inList && hasTime) {
                        viewingString = viewingString.substring(0, viewingString.length - 6);
                    }
                }
            });
            if (viewingString) {
                const viewingElement = viewingWidget.querySelector('.viewing-string');
                if (viewingElement) {
                    viewingElement.innerHTML = viewingString;
                    viewingWidget.classList.add('active');
                }
            }
        });
    }
}
lookForViewings();
// Listen for Jet Filter event
document.addEventListener( 'jet-smart-filters/inited', function( initEvent ) {
    JetSmartFilters.events.subscribe( 'ajaxFilters/updated', function( provider, queryId, response ) {
        lookForViewings();
    } );
} );